import styled, { css } from "styled-components";
export const DoubleCardWrap = styled.a `
	border-radius: 6px;
	background-color: #fff;
	${(props) => {
    return css `
			width: ${props.imgWidth};
		`;
}}
`;
export const Desc = styled.div `
	padding: 9px 6px 6px;
`;
